<template>
  <el-dialog
    top="35vh"
    :visible.sync="showDialog"
    :width="drawerWidth"
    :before-close="handleClose"
    custom-class="custom-scrollable"
    :show-close="false"
  >
    <div
      class="flex flex-col gap-6 items-center text-center -mt-8 px-3 bg-white"
    >
      <span class="self-end cursor-pointer" @click="handleClose">
        <close-icon size="h-5 w-5" />
      </span>

      <h2 class="font-bold text-black-10 text-base -mt-4">Attention</h2>

      <div>
        <p class="font-normal text-root-4 text-sm px-10 break-normal">
          {{ message }}
        </p>
        <strong>{{ invitedEmail || '' }}</strong>
      </div>

      <div class="flex gap-x-5 pt-3 justify-center">
        <div
          @click="handleClose"
          class="w-36 h-12 bg-muted shadow cursor-pointer font-normal text-black-10 hover:opacity-80 rounded-lg flex items-center justify-center"
        >
          No
        </div>

        <div
          @click="verifyDelete"
          class="h-12 w-36 bg-primary cursor-pointer text-white hover:opacity-80 font-normal flex items-center justify-center rounded-lg"
        >
          <spinner
            v-if="isLoading"
            size="small"
            :spacing="40"
            :line-fg-color="$primaryColor"
          />
          <span v-else>Yes</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    beneficiary: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: '',
      required: true
    },
    invitedEmail: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue')
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    verifyDelete () {
      if (this.mode === 'deleteBeneficiary') {
        this.$emit('deleteBeneficiary', this.beneficiary)
        this.handleClose()
      } else if (this.mode === 'deleteWithdrawalMethod') {
        this.$emit('verifyDeleteWithdrawal')
        this.handleClose()
      } else if (this.mode === 'cancelInvite') {
        this.$emit('deleteUserInvite', this.invitedEmail)
      } else if (this.mode === 'resendInvite') {
        this.$emit('resendInvite', this.invitedEmail)
      } else if (this.mode === 'deleteWhitelistedIP') {
        this.$emit('deleteWhitelistedIP')
        this.handleClose()
      }
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 0.5rem !important;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  color: #383839;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
